import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  handleGetAllChefs,
  handleGetPopularDishes,
} from "../../../services/get_without_auth";
import isValidURL from "../../../ValidateUrl";
import { shefDetailPath } from "../../../shefPath";

const PopularCollection = () => {
  const [popularDish, setPopularDish] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const city = JSON.parse(localStorage.getItem("region"));
        if (!city?.id) return;
        
        const popular_dish_response = await handleGetPopularDishes(city.id);
        const chefResponse = await handleGetAllChefs(city.id);

        const currentUser = JSON.parse(localStorage.getItem("user"));
        let filteredDishes = popular_dish_response;
        if (currentUser && currentUser.id) {
          filteredDishes = popular_dish_response.filter(dish => dish.user_id !== currentUser.id);
          console.log("Filtered out own dishes for chef:", currentUser.id);
        }

        // Create chef map for quick lookup
       // Create chef map using ONLY active chefs
const chefMap = new Map();

chefResponse
  .filter((chef) => chef.is_active === 1)
  .forEach((chef) => {
    chefMap.set(chef.id, chef);
  });

// Keep only dishes whose chef is active
const enhancedDishes = filteredDishes
  .filter((dish) => chefMap.has(dish.user_id))
  .map((dish) => ({
    ...dish,
    chef: chefMap.get(dish.user_id),
  }));
        // Sort dishes by rating (highest first)
        const sortedDishes = enhancedDishes.sort((a, b) => {
          const ratingA = parseFloat(a.average_rating) || 0;
          const ratingB = parseFloat(b.average_rating) || 0;
          return ratingB - ratingA; // Descending order
        });

        // Get top 3 dishes
        const topThreeDishes = sortedDishes.slice(0, 3);
        
        setPopularDish(topThreeDishes);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  return (
    <>
      <section className="py-12 bg-gradient-to-br from-gray-100 via-gray-50 to-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <h2 className="text-5xl font-black tracking-tighter mb-4">
              Our Customer <span className="text-red-600">Favorites</span>
            </h2>
            <p className="text-xl text-gray-600 font-light max-w-2xl mx-auto">
              The most ordered and loved dishes from our talented chefs.
            </p>
            <div className="w-24 h-1.5 bg-gradient-to-r from-red-600 to-red-700 rounded-full mx-auto mt-6" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {popularDish.map((dish, index) => (
              <div
                key={index}
                className="bg-white/90 backdrop-blur-md rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden flex flex-col group border-2 border-gray-100 hover:border-red-200 relative"
              >
                {/* Enhanced Card Decorations */}
                <div className="absolute top-6 right-6 w-5 h-5 bg-gradient-to-r from-red-500/40 to-red-600/30 rounded-full z-10 animate-pulse"></div>
                <div className="absolute top-12 right-12 w-3 h-3 bg-red-400/50 rounded-full z-10 animate-pulse delay-300"></div>
                <div className="absolute bottom-6 left-6 w-4 h-4 bg-red-300/40 rounded-full z-10 animate-pulse delay-700"></div>
                <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-600 to-red-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                <div className="relative h-64 overflow-hidden">
                  <img
                    src={
                      dish.logo && isValidURL(dish.logo)
                        ? dish.logo
                        : "https://t4.ftcdn.net/jpg/04/70/29/97/360_F_470299797_UD0eoVMMSUbHCcNJCdv2t8B2g1GVqYgs.jpg"
                    }
                    alt={dish.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <Link 
                      to={`/dish-detail-single/${dish.id}`}
                      className="text-white bg-red-600/90 backdrop-blur-sm px-6 py-3 rounded-full flex items-center space-x-2 font-semibold shadow-lg transform -translate-y-4 group-hover:translate-y-0 transition-transform duration-300"
                    >
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="20" 
                        height="20" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      >
                        <circle cx="9" cy="21" r="1"></circle>
                        <circle cx="20" cy="21" r="1"></circle>
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                      </svg>
                      <span className = "text-white">Quick Add</span>
                    </Link>
                  </div>
                  <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm rounded-full px-4 py-2 shadow-lg">
                    <span className="text-red-600 font-bold text-lg">
                      {(
                        dish.chef_earning_fee +
                        dish.platform_price +
                        dish.delivery_price
                      ).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </span>
                  </div>
                </div>
                <div className="p-8 flex flex-col flex-grow relative">
                  <div className="mb-4">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2 truncate">
                      <Link to={`/dish-detail-single/${dish.id}`}>
                        {dish.name}
                      </Link>
                    </h3>

                    <p className="text-gray-500 font-medium">
                      by{" "}
                      <Link 
                        to={shefDetailPath(dish.chef?.id, dish?.chef?.first_name, dish?.chef?.last_name)}
                        className="text-red-600 font-semibold"
                      >
                        {`${dish?.chef?.first_name || ""} ${dish?.chef?.last_name || ""}`}
                      </Link>
                    </p>
                  </div>

                  <div className="flex items-center space-x-2 mb-6">
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="20" 
                      height="20" 
                      viewBox="0 0 24 24" 
                      fill="#f59e0b" 
                      stroke="#f59e0b" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                    <span className="font-bold text-gray-700 text-lg">
                      {dish?.average_rating
                        ? parseFloat(dish.average_rating).toFixed(1)
                        : 0}
                    </span>
                    <span className="text-gray-500">
                      ({dish?.total_reviews || 0} reviews)
                    </span>
                  </div>

                  <div className="mt-auto">
                    <p className="text-sm font-bold text-gray-400 uppercase mb-3 tracking-wider">
                      Available this week
                    </p>
                    <div className="flex justify-between">
                      {[
                        { day: "S", key: "is_sunday" },
                        { day: "M", key: "is_monday" },
                        { day: "T", key: "is_tuesday" },
                        { day: "W", key: "is_wednesday" },
                        { day: "T", key: "is_thursday" },
                        { day: "F", key: "is_friday" },
                        { day: "S", key: "is_saturday" }
                      ].map(({day, key}, i) => (
                        <div
                          key={i}
                          className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-300 ${
                            dish[key] === 1 
                              ? "bg-gradient-to-r from-red-600 to-red-700 text-white shadow-lg scale-110" 
                              : "bg-gray-100 text-gray-400 hover:bg-gray-200"
                          }`}
                        >
                          {day}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default PopularCollection;